/**
 * Created by sagardesai on 10/07/18.
 */

export const FAVOURITES_LIST_REQUEST = "FAVOURITES_LIST_REQUEST";
export const FAVOURITES_LIST_RECEIVE = "FAVOURITES_LIST_RECEIVE";
export const FAVOURITES_LIST_FAILURE = "FAVOURITES_LIST_FAILURE";
export const RESET_FAVOURITES_LIST = "RESET_FAVOURITES_LIST";

export const SET_SEARCH_FAVOURITES_STATE = "SET_SEARCH_FAVOURITES_STATE";

export const FAVOURITE_UNFAVOURITE_VIEWER_REQUEST = "FAVOURITE_UNFAVOURITE_VIEWER_REQUEST";
export const FAVOURITE_UNFAVOURITE_VIEWER_RECEIVE = "FAVOURITE_UNFAVOURITE_VIEWER_RECEIVE";
export const FAVOURITE_UNFAVOURITE_VIEWER_FAILURE = "FAVOURITE_UNFAVOURITE_VIEWER_FAILURE";
export const RESET_FAVOURITE_UNFAVOURITE_VIEWER = "RESET_FAVOURITE_UNFAVOURITE_VIEWER";